import { Injectable } from '@angular/core';
import { Config } from '../config';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReservationDto } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ReservationRetailService {

  constructor(
    private config: Config,
    private http: HttpClient
  ) { }

  saveReservation(reservation: ReservationDto): Observable<HttpResponse<void>> {
    return this.http.put<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/pub/reservation', reservation);
  }

  cancelReservation(qrCode: string): Observable<HttpResponse<void>> {
    return this.http.delete<HttpResponse<void>>(this.config.get('API_SERVER_URL') + `/pub/reservation/${qrCode}`);
  }
}
